"use client";

import HeroSection from "@/components/Landing/Sections/HeroSection/HeroSection";
import PageContent from "@/components/PageContent/PageContent";
import { useHomeTranslations } from "@/providers/I18n/hooks/useHomeTranslations";

export default function Home() {
	const homeT = useHomeTranslations();

	return (
		<>
			<HeroSection />

			<PageContent>
				<div className="min-h-screen pt-16">1</div>
			</PageContent>
		</>
	);
}
